
import React from 'react';
import { Link } from 'react-router-dom';

interface NavLinksProps {
  currentPath: string;
}

const NavLinks: React.FC<NavLinksProps> = ({ currentPath }) => {
  const isMedsPage = currentPath === '/meds';
  const isResourcesPage = currentPath === '/education';
  const isProvidersPage = currentPath === '/providers';

  return (
    <div className="ml-6 hidden sm:flex space-x-4">
      <Link 
        to="/meds" 
        className={`text-sm font-medium ${isMedsPage ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`}
      >
        Medications
      </Link>
      <Link 
        to="/education" 
        className={`text-sm font-medium ${isResourcesPage ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`}
      >
        Resources
      </Link>
      <Link 
        to="/providers" 
        className={`text-sm font-medium ${isProvidersPage ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`}
      >
        Providers
      </Link>
    </div>
  );
};

export default NavLinks;
